<template>
  <section
    class="title-menu"
    @click="goToCart"
    :class="{ pointer: totalItems > 0, 'with-upload-arc': showUploadArc }"
  >
    <h1 :style="{ color: globe.mainTitleColor }">
      Winkelwagen
    </h1>
    <div class="text-holder">
      <p
        class="empty"
        v-if="totalItems < 1"
        :style="{ color: globe.mainTextColor }"
      >
        Uw winkelwagen<br />is nog leeg
      </p>
      <div class="count" :style="{ color: globe.mainTextColor }" v-else>
        <p :class="{ added: itemAdded }">{{ totalItems }}</p>
      </div>
    </div>

    <button
      v-if="totalItems > 0 && !showUploadArc"
      @click.stop="cartButton.action"
      class="cart-btn"
      :style="{
        backgroundColor: globe.buttonBackgroundColor,
        color: globe.buttonIconColor
      }"
    >
      {{ cartButton.title }}
    </button>

    <cart-upload-arc v-if="showUploadArc"></cart-upload-arc>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import FilesInCartWarning from '@/dialogs/FilesInCartWarning'
import { EventBus } from '@/eventbus/EventBus'
import { useFileListStore } from '@/stores/FileList.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import CartUploadArc from './CartUploadArc.vue'

export default {
  components: {
    CartUploadArc
  },
  data() {
    return {
      itemAdded: false
    }
  },
  methods: {
    goToCart() {
      if (!this.totalItems) {
        return
      } else if (!this.allFilesInCart) {
        this.$modal.show(
          FilesInCartWarning,
          { currentRoute: this.$router.currentRoute.name },
          {
            height: 'auto',
            width: 420,
            adaptive: true
          },
          {}
        )
      } else {
        this.$router.push({ name: 'checkOut' })
      }
    }
  },
  computed: {
    ...mapStores(useCheckOutStore, useFileListStore, usePrintStoreStore),
    hideDeliverOptions() {
      return this.rootStore.theme.customFields.hideDeliverOptions
    },
    hideInvoiceOptions() {
      return this.rootStore.theme.customFields.hideInvoiceOptions
    },
    cartButton() {
      const cartButton = {
        title: '',
        action: ''
      }
      if (this.rootStore.currentSection != 'check-out') {
        cartButton.title = 'Naar Bestellen'
        cartButton.action = () => this.goToCart()
      } else if (
        (this.$route.name === 'checkOutCart' &&
          this.hideDeliverOptions &&
          this.hideInvoiceOptions) ||
        this.$route.name === 'checkOutInvoice'
      ) {
        cartButton.title = 'Naar Controleren'
        cartButton.action = () => this.$router.push({ name: 'checkOutConfirm' })
      } else if (
        (this.$route.name === 'checkOutCart' && this.hideDeliverOptions) ||
        (this.$route.name === 'checkOutDeliver' && !this.hideInvoiceOptions)
      ) {
        cartButton.title = 'Naar Factureren'
        cartButton.action = () => this.$router.push({ name: 'checkOutInvoice' })
      } else if (
        this.$route.name === 'checkOutCart' &&
        !this.hideDeliverOptions
      ) {
        cartButton.title = 'Naar Bezorgen'
        cartButton.action = () => this.$router.push({ name: 'checkOutDeliver' })
      } else if (this.$route.name === 'checkOutConfirm') {
        cartButton.title = 'Winkelwagen'
        cartButton.action = () => this.$router.push({ name: 'checkOutCart' })
      }

      return cartButton
    },

    globe() {
      return this.rootStore.globe
    },
    showUploadArc() {
      // In de checkout blijft de knop waarmee je door de stappen navigeert
      return this.rootStore.currentSection !== 'check-out'
    },
    totalItems() {
      return (
        this.checkOutStore.products.length +
        this.printStoreStore.orderDetails.cart.length
      )
    },
    allFilesInCart() {
      // Return true wanneer alle bestanden OFWEL inCart zijn,
      // OFWEL een uploadFileType van ADDRESS_LIST of ATTACHMENT_FILE hebben
      return (
        this.fileListStore.fileList.filter(
          (file) =>
            !file.inCart &&
            file.uploadFileType !== 'ADDRESS_LIST' &&
            file.uploadFileType !== 'ATTACHMENT_FILE'
        ).length === 0
      )
    }
  },
  watch: {
    totalItems: function (newVal, oldVal) {
      if (newVal > oldVal) {
        this.itemAdded = true

        setTimeout(() => {
          this.itemAdded = false
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-menu {
  padding-top: 31px;
  height: 100%;
  border-radius: 50%;
  position: relative;

  &.glow {
    animation: pulse 1s ease-in-out forwards;
  }
}

h1 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  //  line-height: 26px;
}

.count {
  padding-top: 30px;
  p {
    font-size: 100px;
  }

  .added {
    animation: added 0.4s ease-in-out forwards;
  }
}

.text-holder {
  height: 102px;
}

// Onderin zit de boog voor (nog niet bestelde) bestanden, dus het getal
// schuift omhoog
.with-upload-arc .count {
  padding-top: 0;

  p {
    line-height: 1;
  }
}

.empty {
  font-weight: 500;
  font-size: 14px;
  padding-top: 37px;
}

.cart-btn {
  //width: 44px;
  height: 38px;
  border-radius: 25px;
  padding: 0 12px;
  transition: box-shadow 0.2s;
  font-size: 0.82rem;
  font-weight: 600;
  color: #4f4f4f;
  //color: var(--arch-text-color, #ffffff);

  &:hover {
    box-shadow: var(--default-shadow);

    &:disabled {
      box-shadow: none;
    }
  }

  &:disabled {
    opacity: 0.25;
    cursor: auto;
  }
}

@keyframes added {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

/* @keyframes pulse {
  0% {
    box-shadow: 0px 0px 0 0px;
  }
  50% {
    box-shadow: 0px 0px 38px 0px;
  }
  100% {
    box-shadow: 0px 0px 0 0px;
  }
} */
</style>
